(function () {
  if (window.OelStickyAtc) {
    window.OelStickyAtc.initAll();
    return;
  }

  function parseJson(script) {
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return {};
    }
  }

  function bindQuantity(wrapper) {
    var input = wrapper.querySelector('[data-quantity-input]');
    var increase = wrapper.querySelector('[data-increase-quantity]');
    var decrease = wrapper.querySelector('[data-decrease-quantity]');
    if (!input || !increase || !decrease) return;

    var min = parseInt(input.getAttribute('min'), 10);
    if (isNaN(min)) min = 1;

    increase.addEventListener('click', function (event) {
      event.preventDefault();
      var value = parseInt(input.value, 10);
      value = isNaN(value) ? min : value + 1;
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    decrease.addEventListener('click', function (event) {
      event.preventDefault();
      var value = parseInt(input.value, 10);
      value = isNaN(value) ? min : value - 1;
      input.value = Math.max(min, value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  function init(bar) {
    if (bar.dataset.oelStickyReady === 'true') return;
    bar.dataset.oelStickyReady = 'true';

    var section = bar.closest('[data-section-type="product"]') || document;
    var trigger = section.querySelector('[data-oel-main-atc]') || section.querySelector('[data-add-to-cart]:not([data-oel-sticky-submit])');
    var mainQty = section.querySelector('.product-oel__cart-row [data-quantity-input]') || section.querySelector('[data-quantity-input]:not([data-oel-sticky-qty])');
    var stickyQty = bar.querySelector('[data-oel-sticky-qty]');
    var stickyQtyWrap = bar.querySelector('[data-quantity-selector]');
    var stickySubmit = bar.querySelector('[data-oel-sticky-submit]');
    var mainSubmit = section.querySelector('.product-oel__cart-row [data-add-to-cart]') || section.querySelector('[data-add-to-cart]:not([data-oel-sticky-submit])');
    var priceEls = bar.querySelectorAll('[data-oel-sticky-price]');
    var concentrationEl = bar.querySelector('[data-oel-sticky-concentration]');
    var imageEl = bar.querySelector('[data-oel-sticky-image]');
    var imageWrap = bar.querySelector('.oel-sticky-atc__image');
    var submitText = bar.querySelector('[data-oel-sticky-submit-text]');
    var productTitle = bar.getAttribute('data-product-title') || '';
    var variants = parseJson(bar.querySelector('[data-oel-sticky-variants]'));
    var syncingQty = false;

    if (stickyQtyWrap) bindQuantity(stickyQtyWrap);

    function setVisible(visible) {
      var shown = bar.classList.contains('is-visible');
      if (Boolean(visible) === shown) return;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    function isMobile() {
      return window.matchMedia('(max-width: 767px)').matches;
    }

    function mainAtcPassed() {
      if (!trigger) return false;
      return trigger.getBoundingClientRect().bottom < 0;
    }

    function updateVisibility() {
      if (isMobile()) {
        setVisible(true);
        return;
      }
      setVisible(mainAtcPassed());
    }

    function copyPrice() {
      var source = section.querySelector('.product__block__price .product__price__main');
      if (!source) return;
      priceEls.forEach(function (el) {
        el.innerHTML = source.innerHTML;
        el.querySelectorAll('[id]').forEach(function (node) {
          node.removeAttribute('id');
        });
      });
    }

    function updateFromVariant(variant) {
      if (!variant) return;
      var data = variants[String(variant.id)] || {};
      var concentration = (data.concentration || '').toString().trim();
      if (concentrationEl) {
        concentrationEl.textContent = concentration || productTitle;
        concentrationEl.classList.toggle('oel-sticky-atc__concentration--pill', Boolean(concentration));
      }
      if (imageEl) {
        if (data.image) {
          imageEl.src = data.image;
          imageEl.hidden = false;
          if (imageWrap) imageWrap.hidden = false;
        } else {
          imageEl.removeAttribute('src');
          imageEl.hidden = true;
          if (imageWrap) imageWrap.hidden = true;
        }
      }
      copyPrice();
      if (mainSubmit) {
        stickySubmit.disabled = mainSubmit.disabled;
        var mainText = mainSubmit.querySelector('[data-add-to-cart-text]');
        if (submitText && mainText) submitText.innerHTML = mainText.innerHTML;
      }
    }

    var sourcePrice = section.querySelector('.product__block__price .product__price__main');
    if (sourcePrice) {
      copyPrice();
      new MutationObserver(copyPrice).observe(sourcePrice, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true
      });
    }

    if (stickyQty && mainQty) {
      stickyQty.value = mainQty.value || stickyQty.value;

      stickyQty.addEventListener('change', function () {
        if (syncingQty) return;
        syncingQty = true;
        mainQty.value = stickyQty.value;
        mainQty.dispatchEvent(new Event('change', { bubbles: true }));
        syncingQty = false;
      });

      mainQty.addEventListener('change', function () {
        if (syncingQty) return;
        syncingQty = true;
        stickyQty.value = mainQty.value;
        syncingQty = false;
      });
    }

    if (stickySubmit && mainSubmit) {
      stickySubmit.addEventListener('click', function () {
        if (mainSubmit.disabled) return;
        mainSubmit.click();
      });

      var buttonObserver = new MutationObserver(function () {
        stickySubmit.disabled = mainSubmit.disabled;
        stickySubmit.classList.toggle('loading', mainSubmit.classList.contains('loading'));
        stickySubmit.classList.toggle('has-success', mainSubmit.classList.contains('has-success'));
      });
      buttonObserver.observe(mainSubmit, { attributes: true, attributeFilter: ['class', 'disabled'] });
    }

    section.addEventListener('theme:variant:change', function (event) {
      updateFromVariant(event.detail && event.detail.variant);
    });

    if ('IntersectionObserver' in window && trigger) {
      var observer = new IntersectionObserver(function () {
        updateVisibility();
      }, { threshold: [0, 1] });
      observer.observe(trigger);
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    updateVisibility();
  }

  function initAll() {
    document.querySelectorAll('[data-oel-sticky-atc]').forEach(init);
  }

  window.OelStickyAtc = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
